import { IJsonQuery } from '../json_query';
import { IMakeRequest } from '../utils/request';

export interface IJsonQueryRedirect {
  redirectData: {
    location: string;
    statusCode?: number;
  };
}

export interface IJsonQueryNotFound {
  notFound: true;
}

export type IJsonQueryResponse = IJsonQueryRedirect | IJsonQueryNotFound | { jsonQuery: IJsonQuery };

export function isJsonQueryRedirect(data: IJsonQueryResponse): data is IJsonQueryRedirect {
  return 'redirectData' in data && !!data.redirectData;
}

export function isJsonQueryNotFound(data: IJsonQueryResponse): data is IJsonQueryNotFound {
  return 'notFound' in data;
}

export const getJsonQuery = (
  makeRequest: IMakeRequest,
  subdomain: string,
  path: string,
): Promise<IJsonQueryResponse> => {
  return makeRequest(
    {
      uri: {
        path: `/cian-api/site/v1/get-json-query/`,
      },
      body: JSON.stringify({
        _subdomain: subdomain,
        _path: path,
      }),
      method: 'POST',
    },
    true,
  ).then((response: { data: IJsonQueryResponse; status: 'ok' | 'validationError' }) => {
    if (response.status === 'validationError') {
      return {
        notFound: true,
      } as IJsonQueryNotFound;
    }

    return response.data;
  });
};
